'use strict';

var _ = require('lodash');
function SelectedMarketHelperService() {
  /**
   * Get Selected Market for Market Product and Service Grid for Direct Forecasting Implementation
   * @author Diego Resendez <diego.resendezprado@sabre.com>
   * @param filterDataMarkets [String] Markets from filter data only for Market Analysis Screen
   * @param demandManagementMarket {origin: String, destination: String}  Market Data from Demand Management
   *
   * FIXES:
   * AVPRM-23795: Revert order on how get data when market information from demand management component.
   */
  function getSelectedMarket(filterDataMarkets, demandManagementMarket) {
    if (!_.isEmpty(demandManagementMarket)) {
      return demandManagementMarket;
    }
    if (_.size(filterDataMarkets)) {
      return _.chain(filterDataMarkets).map(function (m) {
        return {
          market: m
        };
      }).first().value();
    }
  }
  return {
    getSelectedMarket: getSelectedMarket
  };
}
SelectedMarketHelperService.$inject = [];
module.exports = SelectedMarketHelperService;